/* eslint-disable no-prototype-builtins */
import * as Yup from 'yup'

// Constants
import { ValidationRegexp } from '@/constants/formValidation'

const formikConfig = (props) => {
  const { t, handleSubmitUserDataForm } = props

  return {
    initialValues: {},

    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required(t('Landing_Page_Invitation_Error_Message_Required'))
        .test('not-empty', t('Landing_Page_Invitation_Error_Message_Required'), (value) => {
          return value && value.trim().length > 0
        }),
      email: Yup.string()
        .required(t('Landing_Page_Invitation_Error_Message_Required'))
        .test('not-empty', t('Landing_Page_Invitation_Error_Message_Required'), (value) => {
          return value && value.trim().length > 0
        })
        .matches(ValidationRegexp.IS_EMAIL, t('Landing_Page_Invitation_Error_Message_Required')),
    }),

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function, no-empty-function
    async onSubmit(data) {
      try {
        await handleSubmitUserDataForm(data)
      } catch (error) {
        console.log('[log] handleSubmitUserDataForm', error)
      }
    },

    enableReinitialize: true,
  }
}

export default formikConfig
